import React, { useState, useContext, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { UserContext } from '../contexts/userContext';
import { useHistory } from 'react-router';
import localRequest from '../services/LocalServer/localRequest';

import { useForm } from 'react-hook-form';
import axios from 'axios';
import './form.css';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function MachineSignIn(props) {
  const page = props.match.params.page;
  const machineName = localStorage.getItem('machineID');
  const history = useHistory();
  const classes = useStyles();
  const [go, setGo] = useState(false);
  const [machineID, setmachineID] = useState(machineName ? machineName : '');

  const loginURL = `${process.env.REACT_APP_SERVER_API}/users/machineLogin`;

  const {
    setUserName,
    setLoginStatus,
    setRole,
    setUserEmail,
    setReferTo,
    setFullAccess,
    setTestMode,
    setMachineID,
  } = useContext(UserContext);

  const {
    register,
    handleSubmit,
    setError,
    getValues,
    formState: { errors },
  } = useForm({});

  function asyncLocalStorage(res) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const user = res.data.result;
        localStorage.setItem('user', JSON.stringify(res.data.result));
        localStorage.setItem('machineID', res.data.machineID);

        const check1 =
          user.role === 'SuperAdmin' ||
          user.role === 'Admin' ||
          (user.role === 'User' && user.fullAccess)
            ? true
            : false;

        const limits = {
          edit_user: check1 || user.limits.edit_user ? true : false,
          edit_group: check1 || user.limits.edit_group ? true : false,
          view_machine: check1 || user.limits.view_machine ? true : false,
          edit_machine: check1 || user.limits.edit_machine ? true : false,
          view_plano: check1 || user.limits.view_plano ? true : false,
          edit_plano: check1 || user.limits.edit_plano ? true : false,
          view_ss: check1 || user.limits.view_ss ? true : false,
          edit_ss: check1 || user.limits.edit_ss ? true : false,
          view_prod: check1 || user.limits.view_prod ? true : false,
          edit_prod: check1 || user.limits.edit_prod ? true : false,
          view_cate: check1 || user.limits.view_cate ? true : false,
          edit_cate: check1 || user.limits.edit_cate ? true : false,
          view_brand: check1 || user.limits.view_brand ? true : false,
          edit_brand: check1 || user.limits.edit_brand ? true : false,
          view_receipt: check1 || user.limits.view_receipt ? true : false,
          edit_receipt: check1 || user.limits.edit_receipt ? true : false,
          view_promo: check1 || user.limits.view_promo ? true : false,
          edit_promo: check1 || user.limits.edit_promo ? true : false,
          view_trans: check1 || user.limits.view_trans ? true : false,
          view_report: check1 || user.limits.view_report ? true : false,
        };

        localStorage.setItem('limits', JSON.stringify(limits));

        const fullName = res.data.result.firstname + ' ' + res.data.result.lastname;
        setLoginStatus(true);
        setUserName(fullName);
        setUserEmail(res.data.result.email);
        setRole(res.data.result.role);
        setReferTo(res.data.result.referTo);
        setFullAccess(res.data.result.fullAccess);
        setmachineID(res.data.machineID);
        setMachineID(res.data.machineID);
        setGo(true);
        window.location.reload();
        resolve();
      });
    });
  }

  const onSubmit = async (data) => {
    const email = getValues('email');
    const password = getValues('password');
    console.log('start');
    await axios
      .post(
        loginURL,
        {
          password: password,
          email: email,
          machineID: data.machine,
        },
        {
          withCredentials: true,
        }
      )
      .then(async (res) => {
        localRequest({
          method: 'post',
          url: 'machineInfo',
          data: {
            token: res.data.accessToken,
            _id: res.data.machineID,
            adminID: res.data.result.role === 'Admin' ? email : res.data.result.referTo,
            name: data.machine,
          },
        }).then((res) => {});
        localStorage.setItem('token', res.data.accessToken);
        await asyncLocalStorage(res);
      })
      .catch((err) => {
        console.log(err);
        if (err) {
          setLoginStatus(false);
          setUserName('');
          if (err.response) {
            setError('password', {
              message: err.response.data.message,
            });
          }
        }
      });
    console.log('end');
  };

  useEffect(() => {
    setTestMode(false);
    localStorage.setItem('testMode', 'false');
    if (go === true || machineID != '') {
      if (page == 'synch') {
        history.push(`/synch`);
      } else {
        history.push(`/machineUI/home/${machineID}/false`);
      }
    }
    // setTestMode(true);
    // localStorage.setItem('testMode', 'true');
    // if (go === true || machineID != '') {
    //   history.push(`/machineUI/home/${machineID}/true`);
    // }
  }, []);

  // if (go === true || machineID != "") {return <Redirect to={`/machineUI/home/${machineID}`} />}
  // else {
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            {...register('email', {
              required: 'Email name is required',
              pattern: {
                value:
                  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                message: 'Please enter a valid email',
              },
            })}
          />
          {errors.email && <p className="signUpErrorMessage">{errors.email.message}</p>}
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            {...register('password', {
              required: 'Password is required',
              minLength: {
                value: 8,
                message: 'Password must longer than 8',
              },
            })}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="machine"
            label="machine ID"
            name="machine"
            autoComplete="machine"
            autoFocus
            {...register('machine', { required: 'machine name is required' })}
          />
          {errors.password && <p className="signUpErrorMessage">{errors.password.message}</p>}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
        </form>
      </div>
    </Container>
  );
  // }
}
